(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Additional card images load only when a shopper uses that gallery.
  function loadCardImages(event) {
    const gallery = event.target.closest?.('.product-grid .card-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('img[data-zpc-src]').forEach(image => {
      image.loading = 'eager';
      image.sizes = image.sizes.replace(/^auto,\s*/, '');
      if (image.dataset.zpcSrcset) {
        image.setAttribute('srcset', image.dataset.zpcSrcset);
        image.removeAttribute('data-zpc-srcset');
      }
      image.setAttribute('src', image.dataset.zpcSrc);
      image.removeAttribute('data-zpc-src');
    });
  }
  document.addEventListener('pointerover', loadCardImages, { capture: true, passive: true });
  document.addEventListener('pointerdown', loadCardImages, { capture: true, passive: true });
  document.addEventListener('click', loadCardImages, true);
  document.addEventListener('touchstart', loadCardImages, { capture: true, passive: true });
  document.addEventListener('focusin', loadCardImages, true);

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
